import { render, staticRenderFns } from "./JoinByLink.vue?vue&type=template&id=96fba78c"
import script from "./JoinByLink.vue?vue&type=script&lang=js"
export * from "./JoinByLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports